module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.currentItem),
      callback: function($$v) {
        _vm.currentItem = $$v
      },
      expression: "currentItem"
    }
  }, _vm._l((_vm.list), function(files, folderName, index) {
    return _c('el-collapse-item', {
      key: folderName,
      attrs: {
        "title": folderName,
        "name": index
      }
    }, [(_vm.currentItem == index) ? _c('div', [_c('images', {
      attrs: {
        "imgs": _vm.getImgs(files, folderName),
        "modalclose": true,
        "keyinput": true,
        "mousescroll": true,
        "showplaybutton": true,
        "showfullbutton": true,
        "showclosebutton": true,
        "showcaption": true,
        "imagecountseparator": "из",
        "showimagecount": true,
        "showthumbnails": true
      }
    })], 1) : _vm._e()])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46349c4a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/portfolio/portfolio.vue
// module id = 576
// module chunks = 0